import { useContext } from "react";
import { Link } from "react-router-dom";
import { getIndependentSymbol, getPercentage, getTimeAgo, translate, translateNumber, translatePercentage } from "../../../helper";
import { ASSET_HOST_BASE_URL, CLOSE_MARGIN_THRESHOLD, otherParty } from "../../../config";
import LangContext from "../../../contexts/LangContext";
import Tab from "../../common/Tab";
import { LoaderInner } from "../../common/Loader";
import "./index.css";

const CloseMargin = (props) => {
  const { lang } = useContext(LangContext);
  const { tab, data, parties } = props;
  const cmRegions = [];

  let updatedAt = new Date("2022-11-20T23:59:59");

  data.provinces.forEach((prov) => {
    prov.districts.forEach((dist) => {
      dist.regions.forEach((reg) => {
        if (reg.rtype === tab) {
          const results = reg.result.filter((r) => r.vote > 0).sort((a, b) => b.vote - a.vote);
          const filteredResult = [results[0]];

          for (let i = 0; i < results.length; i++) {
            if (updatedAt < new Date(results[0].updated_at)) {
              updatedAt = new Date(results[0].updated_at);
            }
            if (i > 0 && results[0].vote - results[i].vote < CLOSE_MARGIN_THRESHOLD) {
              filteredResult.push(results[i]);
            } else {
              continue;
            }
          }

          const region = { ...reg };
          region.result = filteredResult;
          region.province_id = prov.id;
          region.district_id = dist.id;
          region.dist_name_en = dist.name_en;
          region.dist_name_np = dist.name_np;
          region.total = reg.result.reduce((a, b) => a + b.vote, 0);
          if (filteredResult.length > 1) {
            cmRegions.push(region);
          }
        }
      });
    });
  });

  return (
    <>
      {props.showtab ? <Tab tab={tab} handleTabChange={props.handleTabChange} /> : ""}
      <section id="sh-hot-seat-summary" className="sh-summary-section">
        <div className="container">
          {!props.fetched ? (
            <LoaderInner />
          ) : (
            <div className="container-fluid-removed card-removed sh-card-summary">
              <div className="row">
                <div className="col-md-12 mb-3">
                  <span className="float-end">
                    {translate("last_updated", lang)}: &nbsp;{translateNumber(getTimeAgo(updatedAt).time, lang)} {translate(getTimeAgo(updatedAt).metrics, lang)} {translate("ago", lang)}
                  </span>
                  <h3>{translate("close_margins_title", lang)}</h3>
                </div>
                {cmRegions.map((rData, i) => {
                  const diff = rData.result[0].vote - rData.result[1].vote;
                  return (
                    <div key={i} className="col-xl-4 col-md-6 col-sm-6">
                      <div className="sh-widget-card card">
                        <h4>
                          <Link to={"/result/" + rData.province_id + "/" + rData.district_id + "/" + rData.id.toFixed(0) + "?type=" + tab + "&lang=" + lang}> {rData["dist_name_" + lang] + ": " + rData["name_" + lang]}</Link>
                          <span className="sh-region-total-voter">{translate("total_voter", lang) + ": " + translateNumber(rData.total_voter, lang)}</span>
                        </h4>

                        <h4 className="text-center">{rData && <span className={rData.declared ? "sh-count-done" : "sh-counting"}> {rData.declared ? translate("count_done", lang) : rData.result.find((r) => r.vote > 0) ? translate("couting", lang) : ""}</span>}</h4>
                        {rData.result &&
                          rData.result.map((d, j) => {
                            const party = parties.find((par) => par.code === d.party || (d.party.match(/I+\d/) && par.code === "I")) || otherParty;
                            let symbol = party.code.toUpperCase();
                            if (symbol === "I") {
                              symbol = getIndependentSymbol(rData.district_id, rData.id, d.name_en);
                            }
                            const gender = d.gender ? d.gender : "O";

                            return (
                              <div key={j}>
                                <div className="sh-candidate-info">
                                  <div className={"sh-candidate-photo-wrapper" + (!!d.elected ? " sh-highlight-rotate" : "")}>
                                    <img
                                      src={ASSET_HOST_BASE_URL + "/images/parties/" + symbol + ".png"}
                                      alt={party.code.toUpperCase()}
                                      onError={({ currentTarget }) => {
                                        currentTarget.onerror = null; // prevents looping
                                        currentTarget.src = ASSET_HOST_BASE_URL + "/images/parties/O.png";
                                      }}
                                      className="pull-left sh-party-symbol-inner"
                                      width="24px"
                                      height="24px"
                                    />
                                    <img
                                      src={ASSET_HOST_BASE_URL + "/images/candidates/" + rData.district_id + "/" + rData.id + "/" + party.code.toLowerCase() + "-" + d.name_en.toLowerCase().replaceAll(" ", "-") + ".jpg"}
                                      alt={party.code.toUpperCase()}
                                      onError={({ currentTarget }) => {
                                        currentTarget.onerror = null; // prevents looping
                                        currentTarget.src = ASSET_HOST_BASE_URL + "/images/candidates/dummy-" + gender + ".jpg";
                                      }}
                                      className="pull-left sh-candidate-photo"
                                      width="50px"
                                      height="50px"
                                      style={!!d.elected ? { border: "2px solid " + party.color, padding: "2px" } : {}}
                                    />
                                  </div>
                                  <div className="sh-candidate-name">
                                    <Link to={"/candidates/profile/" + d.cid + "?lang=" + lang}>{d["name_" + lang]}</Link>
                                    <br />
                                    <span className="sh-gender-age-party">
                                      <Link to={"/candidates/" + party.code + "?lang=" + lang}>{party["short_name_" + lang] ? party["short_name_" + lang] : party["name_" + lang]}</Link> - {translate(d.gender === "M" ? "male" : d.gender === "F" ? "female" : "other", lang) + ", " + translateNumber(d.age, lang) + " " + translate("years", lang)}
                                    </span>
                                  </div>
                                  <span className="sh-banner-winner">{!!rData.declared && <img src={ASSET_HOST_BASE_URL + "/images/congrats.png"} alt="winner" width="50px" height="43px" />}</span>
                                  <span className="sh-winner data">
                                    {j === 0 && <label className="sh-vote-diff">{"(" + translate("diff", lang) + ": " + translateNumber(diff, lang) + ")"}</label>}&nbsp;
                                    {translateNumber(d.vote, lang)}
                                    <span>{j === 0 && rData.declared ? translate("elected", lang) + " " : ""}</span>
                                  </span>
                                </div>

                                <div className="progress">
                                  <div className={"progress-bar progress-bar-striped" + (rData.declared ? "" : " progress-bar-animated")} role="progressbar" style={{ width: getPercentage(d.vote, rData.total), backgroundColor: party.color }}>
                                    {translatePercentage(d.vote, rData.total, lang)}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        <div className="sh-view-all">
                          <span>
                            <Link to={"/result/" + rData.province_id + "/" + rData.district_id + "/" + rData.id.toFixed(0) + "?type=" + tab + "&lang=" + lang}>{translate("view_all", lang)}</Link>
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default CloseMargin;
